import React from "react";
import {
  Switch,
  Route,
  Redirect,
  useHistory,
  useLocation,
} from "react-router-dom";
import SchoolData from "../users/Schools/SchoolData";
import employeeRedirect from "../../helpers/employeeRedirect";
import axios from "axios";
import { message } from "antd";

function HomePage({ user }) {
  const history = useHistory();
  const { state = {} } = useLocation();
  const { prevLocation } = state;

  return (
    <Switch>
      <Route exact path={`/user/:id`} component={SchoolData} />
      {/* <Route
        exact
        path={`${path}/dashboard/school/:schoolId`}
        component={DashboardLayout}
      /> */}
      <Redirect
        from={`/`}
        to={
          user.role !== "admin" && user.role !== "user"
            ? employeeRedirect(axios, history, prevLocation, message)
            : `/user/${user.uuid}`
        }
      />
    </Switch>
  );
}

export default HomePage;
